import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mapwrap"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "toolswrap",
  id: "toolswrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseBold = _resolveComponent("CloseBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Select = _resolveComponent("Select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: `map${$props.id}`,
    class: _normalizeClass(["map_content", {
      'hide': $data.editMapflag
    }]),
    ref: `map${$props.id}`
  }, null, 10, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "还原最初线段",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "curve",
      onClick: _withModifiers($options.resetrouteLine, ["stop"])
    }, {
      default: _withCtx(() => [_createVNode(_component_CloseBold)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "确定",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "curve",
      onClick: _withModifiers($options.confirmrouteLine, ["stop"])
    }, {
      default: _withCtx(() => [_createVNode(_component_Select)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "确定",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "extent",
      onClick: _withModifiers($options.confirmextent, ["stop"])
    }, {
      default: _withCtx(() => [_createVNode(_component_Select)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })]), _createElementVNode("div", {
    id: "editmap",
    class: _normalizeClass(["map_content", {
      'show': $data.editMapflag
    }]),
    ref: "editmap"
  }, null, 2)]);
}